module.exports = __webpack_public_path__ + "img/deo_white_logo.60063495.png";